import { useEffect, useCallback } from "react";
import { useStoreActions, useStoreState } from "../../appstore";
import { authenticateOidc } from "../../common/auth/oidc";
import AWS from "aws-sdk";
import appConfig from "../../common/appConfig";

const AuthenticateUser = () => {
  const auth = useStoreState((s) => s.internal.auth);
  const setAuthenticationState = useStoreActions(
    (s) => s.setAuthenticationState
  );
  const authenticate = useCallback(async () => {
    if (auth.isAuthenticated) {
      return;
    }
    AWS.config.update({ region: appConfig.awsRegion });
    const result = await authenticateOidc();
    if (!result.success) {
      setAuthenticationState({
        isAuthenticated: false,
        error: result.message,
      });
    } else {
      setAuthenticationState({
        isAuthenticated: true,
      });
    }
  }, [auth, setAuthenticationState]);

  useEffect(() => {
    if (auth.isAuthenticated) {
      return;
    }
    if (auth.error) {
      return;
    }
    authenticate();
  }, [authenticate, auth.error, auth.isAuthenticated]);
  return null;
};
export default AuthenticateUser;
